import { FieldHandler, BoardColumnConfig } from '../types';
import { convertConfigToSheetjs } from '../utils';

export type Config = BoardColumnConfig;

export const handler: FieldHandler<Config> = {
  defaultConfig: {},

  type: 'group-name',

  extractFieldsFromBoard: () => {
    return [
      {
        id: 'item-property_group-name',
        label: 'Group Name',
      },
    ];
  },

  exportTo: (outputFormat, fieldId, boardItem, board, config) => {
    if (outputFormat === 'sheetjs') {
      return {
        ...convertConfigToSheetjs(config),
        v: boardItem.group.title,
        t: 's',
      };
    }
  },
};

export default handler;
